import type { RoleUser } from 'src/auth/types';
import type { NavGroupProps } from 'src/components/nav-section';

import { navData } from '../navConfig';
import { navDataClient } from '../navClient';
import { navDataTeacher } from '../navTeacher';

export const configNavData = (role: RoleUser): NavGroupProps[] => {
  switch (role) {
    case 'administrator':
    case 'manage':
      return navData(role);
    case 'teacher':
      return navDataTeacher;

    default:
      return navDataClient;
  }
};
